import { forwardRef, useRef } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { useKeyPress } from '../../utils/hooks/useKeyPress.js';
import { useHoverDirty } from 'react-use';
import { useMergeRefs } from 'use-callback-ref';
import { Typography } from '../Typography/Typography.js';
import { getStepWrapperStyles, getStepStyles, getProgressWrapperStyles, getProgressStyles, getIconStyles, getTextStyles, getProgressDivisorStyles, getDivisorStyles } from './StepStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { StepStatus } from './types/status.js';
import { Icon } from '../Icon/Icon.js';
import { IconSize } from '../Icon/types/size.js';

const Step = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    label,
    status = StepStatus.STATUS_DISABLED,
    onClick,
    isLastStep,
    ...rest
  } = _ref;
  const stepIsCompleted = status === StepStatus.STATUS_COMPLETED;
  const divRef = useRef(null);
  const mergedRef = useMergeRefs([divRef, ref]);
  const isHovering = useHoverDirty(divRef);
  const handleOnEnter = event => {
    event.preventDefault();
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  const {
    handleKeyPress
  } = useKeyPress({
    onEnter: handleOnEnter
  });
  return jsxs("div", {
    css: getStepWrapperStyles,
    children: [jsx("div", {
      role: "button",
      tabIndex: 0,
      onClick: onClick,
      onKeyUp: handleKeyPress,
      "aria-disabled": status === StepStatus.STATUS_DISABLED,
      css: getStepStyles(status, stepIsCompleted && isHovering),
      ref: mergedRef,
      ...rest,
      children: jsxs("span", {
        css: getProgressWrapperStyles,
        children: [jsx("span", {
          css: getProgressStyles(status),
          children: stepIsCompleted && jsx(Icon, {
            size: IconSize.SIZE_SMALL,
            name: IconNames.CHECK_MARK,
            css: getIconStyles(stepIsCompleted && isHovering)
          })
        }), jsx(Typography, {
          variant: "small",
          variantTablet: "subtitle2",
          "aria-label": label,
          css: getTextStyles(status),
          children: label
        })]
      })
    }), jsx("div", {
      css: getProgressDivisorStyles,
      children: jsx("span", {
        css: getDivisorStyles(status, isLastStep)
      })
    })]
  });
});
Step.displayName = 'Step';

export { Step };
//# sourceMappingURL=Step.js.map
